import { useEffect, useState } from "react"
import userNameService from "../../services/UserNameService"

export default function UserDisplayById({
  id
}: {
  id: number
}) {
  const [username, setUsername] = useState('')
  useEffect(() => {
    console.log('### get Name id', id)
    userNameService.getName(id).then((name) => {
      console.log('### get Name done', name)
      setUsername(name)
    })
  }, [id])
  return <>{username}</>
}
